module.exports = __webpack_public_path__ + "static/media/atletismo.118cd4a1.jpg";